/* ============================================================
   Custom Cart Drawer JS — Lunafaro
   Handles: Shipping Protection toggle, Free Shipping bar,
   Shadow DOM express button styling, theme.CartForm integration
   ============================================================ */

(function() {
  'use strict';

  var CONFIG = {
    shippingProtectionVariantId: 43768900681831,
    shippingProtectionHandle: 'shipping-protection',
    shippingProtectionPrice: 250, // cents
    storageKey: 'lf_shipping_protection',
    tiers: [
      { spend: 8500, save: 1000 },   // $85 → save $10
      { spend: 13000, save: 2000 },  // $130 → save $20
      { spend: 20000, save: 3000 }   // $200 → save $30
    ]
  };

  var CustomCartDrawer = {
    initialized: false,
    isUpdating: false,
    hasAutoAdded: false,

    init: function() {
      if (this.initialized) return;
      this.initialized = true;

      document.addEventListener('cart:updated', this.onCartUpdated.bind(this));
      this.observeDrawer();
      this.hookCartForm();
      this.styleExpressButtons();
    },

    observeDrawer: function() {
      var drawer = document.getElementById('CartDrawer');
      if (!drawer) return;

      var self = this;
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'class') {
            if (drawer.classList.contains('drawer--is-open')) {
              self.onDrawerOpen();
            }
          }
        });
      });
      observer.observe(drawer, { attributes: true });
    },

    hookCartForm: function() {
      if (typeof theme === 'undefined' || !theme.CartForm) return;

      var originalCartMarkup = theme.CartForm.prototype.cartMarkup;
      var self = this;

      theme.CartForm.prototype.cartMarkup = function(text) {
        originalCartMarkup.call(this, text);
        setTimeout(function() {
          self.syncFromCart();
        }, 100);
      };
    },

    onDrawerOpen: function() {
      var self = this;
      this.fetchCart(function(cart) {
        var hasProtection = self.cartHasProtection(cart);
        var shouldProtect = self.getProtectionState();

        self.setToggleUI(hasProtection);

        if (shouldProtect && !hasProtection && !self.hasAutoAdded) {
          self.hasAutoAdded = true;
          self.addProtectionToCart();
        }

        self.updateCartCount(cart);
        self.updateTiers(cart);
        self.updatePricing(cart);
        self.loadRecommendations(cart);
      });

      this.styleExpressButtons();
      setTimeout(function() { self.styleExpressButtons(); }, 1000);
      setTimeout(function() { self.styleExpressButtons(); }, 3000);
    },

    onCartUpdated: function() {
      var self = this;
      setTimeout(function() { self.syncFromCart(); }, 150);
    },

    /* ==========================================
       Cart fetching
       ========================================== */

    fetchCart: function(callback) {
      fetch(theme.routes.cart, { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) { if (callback) callback(cart); })
        .catch(function() {});
    },

    syncFromCart: function() {
      var self = this;
      this.fetchCart(function(cart) {
        var hasProtection = self.cartHasProtection(cart);
        self.setToggleUI(hasProtection);
        self.setProtectionState(hasProtection);
        self.updateCartCount(cart);
        self.updateTiers(cart);
        self.updatePricing(cart);
      });
    },

    cartHasProtection: function(cart) {
      return cart.items.some(function(item) {
        return item.variant_id === CONFIG.shippingProtectionVariantId;
      });
    },

    /* ==========================================
       Shipping Protection
       ========================================== */

    getProtectionState: function() {
      var stored = localStorage.getItem(CONFIG.storageKey);
      if (stored === null) return true;
      return stored === 'true';
    },

    setProtectionState: function(state) {
      localStorage.setItem(CONFIG.storageKey, state ? 'true' : 'false');
    },

    setToggleUI: function(isOn) {
      var toggle = document.getElementById('ShippingProtectionToggle');
      if (toggle) toggle.checked = isOn;
    },

    toggleProtection: function(isOn) {
      if (this.isUpdating) return;
      this.isUpdating = true;
      this.setProtectionState(isOn);

      var self = this;
      if (isOn) {
        this.addProtectionToCart(function() { self.isUpdating = false; });
      } else {
        this.removeProtectionFromCart(function() { self.isUpdating = false; });
      }
    },

    addProtectionToCart: function(callback) {
      var self = this;
      this.fetchCart(function(cart) {
        if (self.cartHasProtection(cart)) {
          if (callback) callback();
          return;
        }

        fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: CONFIG.shippingProtectionVariantId, quantity: 1 }] })
        })
        .then(function() {
          document.dispatchEvent(new CustomEvent('cart:build'));
          if (callback) callback();
        })
        .catch(function() { if (callback) callback(); });
      });
    },

    removeProtectionFromCart: function(callback) {
      this.fetchCart(function(cart) {
        var item = cart.items.find(function(i) {
          return i.variant_id === CONFIG.shippingProtectionVariantId;
        });
        if (!item) { if (callback) callback(); return; }

        fetch(theme.routes.cartChange, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: item.key, quantity: 0 })
        })
        .then(function() {
          document.dispatchEvent(new CustomEvent('cart:build'));
          if (callback) callback();
        })
        .catch(function() { if (callback) callback(); });
      });
    },



    updateCartCount: function(cart) {
      var visibleCount = 0;
      cart.items.forEach(function(item) {
        if (item.variant_id !== CONFIG.shippingProtectionVariantId) {
          visibleCount += item.quantity;
        }
      });
      var countEl = document.querySelector('.cart-drawer__count');
      if (countEl) countEl.textContent = visibleCount;
    },

    /* ==========================================
       Express Checkout — Shadow DOM styling
       ========================================== */

    styleExpressButtons: function() {
      var expressContainer = document.querySelector('.cart-drawer__express');
      if (!expressContainer) return;

      if (expressContainer.querySelector('.cart-drawer__express-grid')) return;

      var accelCheckout = expressContainer.querySelector('shopify-accelerated-checkout-cart');
      if (!accelCheckout) return;

      var buttons = accelCheckout.querySelectorAll('shop-pay-wallet-button, shopify-paypal-button, shopify-google-pay-button, google-pay-button');
      if (buttons.length === 0) return;

      var grid = document.createElement('div');
      grid.className = 'cart-drawer__express-grid';

      buttons.forEach(function(btn) {
        grid.appendChild(btn);
      });

      var origContainer = expressContainer.querySelector('.additional-checkout-buttons--vertical');
      if (origContainer) origContainer.classList.add('is-extracted');

      expressContainer.appendChild(grid);
    },

    /* ==========================================
       Tiered Discount Progress Bar
       ========================================== */

    updateTiers: function(cart) {
      var progressEl = document.querySelector('[data-tier-progress]');
      var msgEl = document.querySelector('[data-tier-msg]');
      var fillEl = document.querySelector('[data-tier-fill]');
      if (!progressEl || !msgEl || !fillEl) return;

      // Calculate subtotal excluding shipping protection
      var subtotal = 0;
      cart.items.forEach(function(item) {
        if (item.variant_id !== CONFIG.shippingProtectionVariantId) {
          subtotal += item.final_line_price;
        }
      });

      var tiers = CONFIG.tiers;
      var maxSpend = tiers[tiers.length - 1].spend;

      // Find highest reached tier and next tier
      var reachedIndex = -1;
      for (var i = tiers.length - 1; i >= 0; i--) {
        if (subtotal >= tiers[i].spend) {
          reachedIndex = i;
          break;
        }
      }

      // Calculate fill percentage
      // The bar spans from $0 to the max tier ($200)
      var fillPct = Math.min((subtotal / maxSpend) * 100, 100);
      fillEl.style.width = fillPct + '%';

      // Toggle green fill when at least first tier is reached
      if (reachedIndex >= 0) {
        fillEl.classList.add('is-active');
      } else {
        fillEl.classList.remove('is-active');
      }

      // Update milestone markers
      for (var j = 0; j < tiers.length; j++) {
        var marker = document.querySelector('[data-tier-marker="' + j + '"]');
        if (!marker) continue;
        if (j <= reachedIndex) {
          marker.classList.add('is-reached');
        } else {
          marker.classList.remove('is-reached');
        }
      }

      // Update motivational message
      var nextIndex = reachedIndex + 1;
      if (subtotal === 0) {
        msgEl.innerHTML = 'Add items to unlock savings!';
      } else if (nextIndex < tiers.length) {
        var next = tiers[nextIndex];
        var remaining = ((next.spend - subtotal) / 100).toFixed(2).replace(/\.00$/, '');
        msgEl.innerHTML = 'Spend <strong>$' + remaining + ' more</strong> to save <strong>$' + (next.save / 100) + '</strong>';
      } else {
        // All tiers reached
        msgEl.innerHTML = 'Maximum savings unlocked!';
      }
    },

    /* ==========================================
       Pricing Summary — dynamic update
       ========================================== */

    formatMoney: function(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    updatePricing: function(cart) {
      var pricingEl = document.querySelector('.cart-drawer__pricing');
      if (!pricingEl) return;

      var discounts = cart.cart_level_discount_applications || [];
      var html = '';

      if (discounts.length > 0) {
        // Subtotal row (original price, struck through)
        html += '<div class="cart-drawer__pricing-row">';
        html += '<span class="cart-drawer__pricing-label">Subtotal</span>';
        html += '<span class="cart-drawer__pricing-original">' + this.formatMoney(cart.original_total_price) + '</span>';
        html += '</div>';

        // Discount rows
        for (var i = 0; i < discounts.length; i++) {
          html += '<div class="cart-drawer__pricing-row">';
          html += '<span class="cart-drawer__pricing-label cart-drawer__pricing-discount-name">' + discounts[i].title + '</span>';
          html += '<span class="cart-drawer__pricing-discount-amount">-' + this.formatMoney(discounts[i].total_allocated_amount) + '</span>';
          html += '</div>';
        }

        // Total row (red when discounted)
        html += '<div class="cart-drawer__pricing-row cart-drawer__pricing-total-row">';
        html += '<span class="cart-drawer__pricing-label">Total</span>';
        html += '<span class="cart-drawer__pricing-total cart-drawer__pricing-total--red" data-subtotal>' + this.formatMoney(cart.total_price) + '</span>';
        html += '</div>';
      } else {
        // Simple subtotal row — no discounts
        html += '<div class="cart-drawer__pricing-row cart-drawer__pricing-total-row">';
        html += '<span class="cart-drawer__pricing-label">Subtotal</span>';
        html += '<span class="cart-drawer__pricing-total" data-subtotal>' + this.formatMoney(cart.total_price) + '</span>';
        html += '</div>';
      }

      pricingEl.innerHTML = html;
    },

    /* ==========================================
       You May Also Like — Recommendations
       ========================================== */

    recsLoaded: false,
    lastRecsProductId: null,

    loadRecommendations: function(cart) {
      var container = document.querySelector('[data-cart-recommendations]');
      if (!container) return;

      var scrollEl = container.querySelector('[data-recs-scroll]');
      if (!scrollEl) return;

      var limit = Math.min(parseInt(container.getAttribute('data-recs-limit')) || 3, 3);

      // Find first non-protection product
      var sourceItem = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id !== CONFIG.shippingProtectionVariantId) {
          sourceItem = cart.items[i];
          break;
        }
      }

      if (!sourceItem) {
        container.style.display = 'none';
        return;
      }

      // Don't reload if same product
      if (this.recsLoaded && this.lastRecsProductId === sourceItem.product_id) {
        container.style.display = '';
        return;
      }

      this.lastRecsProductId = sourceItem.product_id;
      var self = this;

      // Collect IDs of items already in cart to exclude them
      var cartProductIds = {};
      cart.items.forEach(function(item) {
        cartProductIds[item.product_id] = true;
      });

      fetch('/recommendations/products.json?product_id=' + sourceItem.product_id + '&limit=' + (limit + 5))
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = (data.products || []).filter(function(p) {
            return !cartProductIds[p.id];
          }).slice(0, limit);

          if (products.length === 0) {
            container.style.display = 'none';
            return;
          }

          scrollEl.innerHTML = '';
          products.forEach(function(product) {
            var imgSrc = product.featured_image ? product.featured_image.replace(/\.(jpg|png|jpeg|gif|webp)/, '_300x.$1') : '';
            var price = (product.price / 100).toFixed(2);
            var comparePrice = product.compare_at_price ? (product.compare_at_price / 100).toFixed(2) : null;
            var variantId = product.variants && product.variants[0] ? product.variants[0].id : null;

            var card = document.createElement('div');
            card.className = 'cart-drawer__rec-card';
            card.innerHTML =
              '<a href="' + product.url + '" class="cart-drawer__rec-img-wrap">' +
                (imgSrc ? '<img src="' + imgSrc + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
              '</a>' +
              '<div class="cart-drawer__rec-info">' +
                '<a href="' + product.url + '" class="cart-drawer__rec-title">' + product.title + '</a>' +
                '<div class="cart-drawer__rec-price">' +
                  (comparePrice ? '<span class="cart-drawer__rec-compare">$' + comparePrice + '</span> ' : '') +
                  '<span' + (comparePrice ? ' class="cart-drawer__rec-sale"' : '') + '>$' + price + '</span>' +
                '</div>' +
                (variantId ? '<button type="button" class="cart-drawer__rec-add" data-variant-id="' + variantId + '">+ Add</button>' : '') +
              '</div>';

            scrollEl.appendChild(card);
          });

          container.style.display = '';
          self.recsLoaded = true;
        })
        .catch(function() {
          container.style.display = 'none';
        });
    }
  };

  /* ==========================================
     Initialize
     ========================================== */
  function onReady() {
    CustomCartDrawer.init();

    document.addEventListener('change', function(evt) {
      if (evt.target && evt.target.id === 'ShippingProtectionToggle') {
        CustomCartDrawer.toggleProtection(evt.target.checked);
      }
    });

    // Recommendation "Add" button handler
    document.addEventListener('click', function(evt) {
      var addBtn = evt.target.closest('.cart-drawer__rec-add');
      if (!addBtn) return;

      var variantId = addBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';

      fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
      .then(function() {
        CustomCartDrawer.recsLoaded = false;
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function() {
        addBtn.disabled = false;
        addBtn.textContent = '+ Add';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  window.CustomCartDrawer = CustomCartDrawer;
})();
